import router from "@/router"
export default {
	average(nums) {
		return Math.floor(nums.reduce((a, b) => (a + b)) / nums.length, 0);
	},
	capitalizeFirstLetter: str => str.charAt(0).toUpperCase() + str.slice(1),
	mwTranslate(key, value){
		var translations = {
			results: {
				series: "Datenserien",
				average: "Durchschnitt" 
			},
			type: {
				poll: "Quick-Poll",
				delegation: "Delegation"
			}, 
			status: {
				in_progress: "In Bearbeitung",
				not_started: "Zu Bearbeiten",
				complete: "Bearbeitet",
				incomplete: "In Bearbeitung", 
				pending: "Unbearbeitet"
			},
			date: {
				'Last login': "Zuletzt aktiv", 
				'Last updated':  'Stand'
			}
		}

		return translations[key][value] || value ;
	},
	scoreColor(score){
		if( score > 76 ){
			return "green"
		}
		if( score > 51 ){
			return "green lighten-2"
		}
		if( score > 26 ){
			return "yellow"
		}
		if( score > 1 ){
			return "orange"
		}
		if( score == 0 ){
			return "red";
		}
		return "grey"
	},
	linkTo(path){
		router.push(`/${path}`)
	},
	generateId() {
		var result = '';
		var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		var charactersLength = characters.length;
		for ( var i = 0; i < 12; i++ ) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength));
		}
		return result;
	},
	prettyPrint(str, strCase ){
		if( !str ){ return "" }
		str = str.split("_").join(" ");
		str = str.split("-").join(" ");
		switch (strCase){
			case "TITLE":
				var sentence = str.toLowerCase().split(" ");
				for(var i = 0; i< sentence.length; i++){
					sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
				}
				return sentence.join(" ");
			case "SENTENCE":
				str = str.toLowerCase();
				str = str[0].toUpperCase() + str.slice(1);
				return str;
			case "LOWER":
				return str.toLowerCase();
			case "UPPER":
				return str.toUpperCase();
			default:
				return str;
		}
	},
	sortByKey(array, key) {
		return array.sort(function(a, b) {
			var x = a[key]; var y = b[key];
			return ((x < y) ? -1 : ((x > y) ? 1 : 0));
		});
	},
	replaceSpaces(str){
		return str.replace(/ /g, ";");
	},
	smoothScroll(target) {
		var scrollContainer = target;
		do { 
		scrollContainer = scrollContainer.parentNode;
		if (!scrollContainer) return;
		scrollContainer.scrollTop += 1;
		} while (scrollContainer.scrollTop == 0);

		var targetY = 0;
		do { //find the top of target relatively to the container
		if (target == scrollContainer) break;
		targetY += target.offsetTop;
		} while (target == target.offsetParent);

		var scrol = function(c, a, b, i) {
			i++; if (i > 30) return;
			c.scrollTop = a + (b - a) / 30 * i;
			setTimeout(function(){ scrol(c, a, b, i); }, 10);
		}
		scrol(scrollContainer, scrollContainer.scrollTop, targetY, 0);
	}

}